exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/phone/config/vna-campaign/modals/vna-campaign-action-file-preview/vna-campaign-action-file-preview.component.scss
// module id = ../../../../../src/app/phone/config/vna-campaign/modals/vna-campaign-action-file-preview/vna-campaign-action-file-preview.component.scss
// module chunks = main